import { type TransactionHash, TRANSACTION_TYPES, EVENT_SUFFIXES } from "@/types";
import { createEventEmitter } from "@/events";

export const WITHDRAW_EVENTS = {
    SUCCESS: `${TRANSACTION_TYPES.WITHDRAW}:${EVENT_SUFFIXES.SUCCESS}`,
} as const;

export interface WithdrawSuccessPayload {
    transactionHash: TransactionHash;
    withdrawAmount: string;
}

export interface WithdrawEventPayloads extends Record<string, unknown> {
    [WITHDRAW_EVENTS.SUCCESS]: WithdrawSuccessPayload;
}

export const withdrawEventEmitter = createEventEmitter<WithdrawEventPayloads>();
